import { AppLayout } from './AppLayout';

export function App() {
  return <AppLayout />;
}
